import { useOpenStory } from "@/app/lib/features/story/story.hook";
import { FC, memo } from "react";
import { HomeStory } from "@/app/lib/features/home/home.types";
import FallbackImage from "@/app/components/elements/FallbackImage";
import { trackInteraction } from "@/app/lib/tracking/interactions";

interface StoryCardProps {
  story: HomeStory;
  index: number;
}

const StoryCard: FC<StoryCardProps> = ({ story, index }) => {
  // Dispatch-only: useStory() burada tüm slice aboneliğini VE görüntüleyiciye ait
  // progress/keydown effect'lerini her kartta bir kez daha kuruyordu.
  const handleOpen = useOpenStory();

  return (
    <button
      type="button"
      onClick={() => { trackInteraction("stories", story.id, "click"); handleOpen(index); }}
      // Sabit genişlik YOK ve bu bilinçli: slidesPerView sayısal olduğu için
      // slide genişliğini Swiper belirliyor, kart onun ortasında duruyor.
      // Karta sabit genişlik vermek yalnızca slidesPerView "auto" iken gerekli
      // (slide genişliği = kart genişliği olduğu durum) — burada gereksiz ve
      // etiketin nefes alanını boş yere kısıyordu.
      className="gap-1.5 group flex items-center flex-col justify-center cursor-pointer p-1"
      aria-label={`${story.title} hikayesini ac`}
    >
      <div className="relative w-14 h-14 sm:w-16 sm:h-16 md:w-17 md:h-17 lg:w-19 lg:h-19">
        <div className="absolute inset-0 rounded-full bg-linear-to-tr from-yellow-400 via-pink-500 to-purple-600 p-0.5 group-hover:scale-105 transition-transform duration-300 ease-in-out">
          <div className="w-full h-full rounded-full bg-white p-0.5">
            <div className="relative w-full h-full rounded-full overflow-hidden bg-linear-to-br from-gray-50 to-gray-100 flex items-center justify-center">
              <FallbackImage
                src={story.cover_url}
                alt=""
                fill
                className="object-cover"
                fallbackClassName="object-contain scale-75 opacity-90"
                sizes="(max-width: 640px) 56px, (max-width: 768px) 64px, (max-width: 1024px) 68px, 76px"
                priority={index < 3}
              />
            </div>
          </div>
        </div>
      </div>
      <p className="font-medium text-[10px] sm:text-xs md:text-sm text-center transition-all duration-300 ease-in-out group-hover:text-main line-clamp-2 leading-tight max-w-15 sm:max-w-17.5 md:max-w-20">
        {story.title}
      </p>
    </button>
  );
};

export default memo(StoryCard);
